import React, { useEffect, useState } from 'react';

import './boxWipe.scss';

export default ({ className, onAnimationEnd, color1, color2, color3 }) => {
  const [hypotenuse, setHypotenuse] = useState(1920);

  useEffect(() => {
    const wSquared = window.innerWidth * window.innerWidth;
    const hSquare = window.innerHeight * window.innerHeight;
    const hyp = Math.sqrt(hSquare + wSquared);
    setHypotenuse(hyp);
  }, []);
  return (
    <div
      className={`box-wipe-transition ${className}`}
      style={{ width: `${1.5 * hypotenuse}px`, height: `${1.5 * hypotenuse}px` }}
    >
      <div
        className="box"
        style={{ backgroundColor: color1 }}
        onAnimationEnd={onAnimationEnd}
      ></div>
      <div className="box" style={{ backgroundColor: color2 }}></div>
      <div className="box" style={{ backgroundColor: color3 }}></div>
    </div>
  );
};
